var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHintIcon = function SvgHintIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FAECCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1818 25.5C23.5636 24.2539 24.3551 23.1914 25.1386 22.1328C25.3455 21.8555 25.5523 21.5781 25.7511 21.2969C26.5386 20.1836 27 18.8359 27 17.3789C27 13.5781 23.8659 10.5 20 10.5C16.1341 10.5 13 13.5781 13 17.375C13 18.832 13.4614 20.1836 14.2489 21.293C14.4477 21.5742 14.6545 21.8516 14.8614 22.1289C15.6449 23.1914 16.4364 24.2539 16.8182 25.5H23.1818ZM20 30.5C21.758 30.5 23.1818 29.1016 23.1818 27.375V26.75H16.8182V27.375C16.8182 29.1016 18.242 30.5 20 30.5ZM16.8182 17.375C16.8182 17.7188 16.5318 18 16.1818 18C15.8318 18 15.5455 17.7188 15.5455 17.375C15.5455 14.957 17.5381 13 20 13C20.35 13 20.6364 13.2812 20.6364 13.625C20.6364 13.9688 20.35 14.25 20 14.25C18.242 14.25 16.8182 15.6484 16.8182 17.375Z",
    fill: "#EFB520"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHintIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hint-icon.9eb9e179.svg";
export { ForwardRef as ReactComponent };